
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.688 0c-4.063 0-6.91 2.82-8.532 6.438-1.62 3.617-2.234 8.128-2.156 12.156.09 4.547 1.906 9.718 1.906 9.718a1.002 1.002 0 001.375.563c1.684-.766 4.875-1.594 6.969-1.75.934-.07 2.703.117 4.156.344a60.63 60.63 0 012.625.468.999.999 0 001.125-.593s2.344-5.457 2.782-11.313c.167-2.254-.149-6.074-1.594-9.5-.723-1.715-1.73-3.316-3.157-4.531-1.425-1.215-3.277-2-5.5-2zm0 2c1.769 0 3.078.586 4.187 1.531 1.11.946 1.988 2.27 2.625 3.781 1.273 3.02 1.61 6.696 1.469 8.563-.36 4.797-2.004 8.941-2.407 9.938-.464-.094-.847-.153-1.875-.313-1.507-.234-3.261-.473-4.593-.375-2.078.152-4.586.813-6.563 1.563-.386-1.223-1.465-4.766-1.531-8.157-.074-3.789.527-8.07 1.969-11.281C19.41 4.04 21.523 2 24.687 2zm7.656 33.25a1.044 1.044 0 00-.188.031.466.466 0 00-.062.032c-.809.207-2.867.898-6.219 1.187-3.797.332-7.688-.125-7.688-.125a1.004 1.004 0 00-1.125 1c-.023 2.89.438 5.977 1.97 8.438 1.53 2.46 4.222 4.187 8.155 4.187 2.547 0 4.747-1.64 5.875-4.156 1.13-2.516 1.305-5.922.25-9.844a1 1 0 00-.968-.75zm-.813 2.281c.645 3.09.48 5.73-.312 7.5C30.336 47.004 28.922 48 27.187 48c-3.378 0-5.246-1.29-6.468-3.25-1.055-1.695-1.465-3.977-1.563-6.281 1.297.113 3.79.3 6.875.031 2.672-.23 4.414-.672 5.5-.969z"}})])
          )
        }
      }
    